import React from "react";
import { connect } from "react-redux";

import Header from "../../../components/header";
import Footer from "../../../components/footer";
import  PatientPayment from './payment';
import SavedCards from './savedCards'

import $ from 'jquery';
import {footer} from "../../../components/footerSize";

 class Paymentpage extends React.Component {
  constructor(props) {

    super(props)
    this.state = {
      userType:"",
      facility : "",
      patient  : "",
      admin : "",
      employee : "",
    
      index:1
    };
  }


  settingsNav = (e) =>{
    e.preventDefault();
       let selectedItem = e.target.id;
       this.setState({
         index : selectedItem
       })
  }

  changePage = () =>{
     this.setState({
      index : 2

    })
  }

  pageChange = () =>{
  
    this.setState({
      index :1
    })
    }
    componentDidMount() {
      // onDocumentReady function bind
      $(document).ready(function () {
        footer("#content");
    });

    // onResize bind of the function
    $(window).resize(function () {
        footer("#content");
    });
  }
    
    componentWillReceiveProps = nextProps =>{
      if(nextProps.isAutoPayStatus){
          this.props.history.push("/RequestStatus")
      }
  }
 


 
  render() {
    
    const { addPaymentMethod, savedCards, index  } = this.state;

    return (
      <React.Fragment>
        <Header  status ={"afterLogin"}  routes={[ { "name": "Home", "route": "/PatientHome", },{"name" : "Select a Practice/Doctor", "route" : "/PatientRequest",}, { "name": "Select Record", "route": "/PatientRecord", }, {"name" : "Confirm Details", "route": "/FinalRequest"}, {"name" : "Payment", "route": "/Paymentpage"}]}  />

 
        <div className="content">

          <div className="contentSection" id="content">
            <div className="container-fluid">
            {/* <div className="titleContent">
                <ul className="breadcrumb">
                    <li><a href="#">Patient</a></li>
                    <li><NavLink to="/PatientHome">Home</NavLink></li>
                     <li><NavLink to="/PatientRequest">Select a Practice</NavLink></li>
                    {/* <li><NavLink to="/PatientRecord">Select a Record</NavLink></li>
                    <li><NavLink to="/FinalRequest">Finalize</NavLink></li> 
                    <li className="active"><NavLink to="/Paymentpage">Payment</NavLink></li>
                </ul>
            
            </div> */}
            <div className="bodyContent">
              <h3 className="title-text">Step 4 : Payment Section</h3>
                <div className=" set-page row">
                  <div className="set-but">
                    <div className="col-lg-3 col-md-3">
                      <ul className="set-ul"type="none">
                   
                      <>
                      <li onClick={this.settingsNav} id={1} className={index == 1 ? "active" : ""}>
                             Saved Cards 
                        </li>
                      <li onClick={this.settingsNav} id={2} className={index ==2 ? "active" : ""} >
                             Add Payment Method 
                        </li>

               

                     </>
                    
                         
                      </ul>
                    </div></div>


                  <div className="col-lg-9 col-md-9">
                     
                    
                  {index ==1  &&
                      <SavedCards  changePage={this.changePage}  />
                  }
                     {index == 2 &&
                      <PatientPayment pageChange={this.pageChange} />
                    }



                     

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        {/* <!-- Edit data --> */}


      </React.Fragment>
    )
  }
}
const mapStateToProps = state => ({
  isAutoPayStatus : state.patientReducer.isAutoPayStatus,


});

// const mapDispatchToProps = dispatch => ({
//   ChangePasswordService: (payLoad, token) => dispatch(ChangePasswordService(payLoad, token))
// });

export default connect(
  mapStateToProps,
  null
)(Paymentpage);



